import React from 'react';
import styled from 'styled-components';
import { widgetContainer } from '@/styles/theme';
import type { MessageProps } from '@/types';

interface StyledMessageProps {
  $large?: boolean;
  $vertical?: boolean;
  $color?: string;
}

const StyledMessage = styled.p<StyledMessageProps>`
  margin: 0 0 12px;
  font-size: 14px;
  width: 100%;
  max-width: 266px;
  text-align: center;
  opacity: 0.75;
  overflow-wrap: break-word;
  min-width: 0;

  ${widgetContainer.wide} {
    font-size: 20px;
    text-align: right;
    padding-right: 34px;
    margin-right: 24px;
    margin-bottom: 0;
    border-color: ${({ theme }) => theme.colors.border};
    border-right: 4px solid ${({ theme }) => theme.colors.border};
  }

  ${({ $large }) =>
    $large &&
    `
    font-size: 20px;
    margin-bottom: 36px;
    max-width: 200px;
    
    ${widgetContainer.wide} {
      font-size: 28px;
      margin-bottom: 0;
      max-width: 220px;
    }
  `}

  ${({ $vertical }) =>
    $vertical &&
    `
    margin: 0 0 12px;
    font-size: 14px;
    text-align: center;
    opacity: 0.75;
    width: auto;
    max-width: 100%;
    
    ${widgetContainer.wide} {
      text-align: center;
      padding-right: 0;
      margin-right: 0;
      border-right: none;
    }
  `}
`;

const Message: React.FC<MessageProps> = ({
  color,
  large,
  vertical,
  children,
}) => {
  return (
    <StyledMessage $large={large} $vertical={vertical} $color={color}>
      {children}
    </StyledMessage>
  );
};

export default Message;
